"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _ = require("./..");
var _styles = require("../../styles");
var _Popover = _interopRequireDefault(require("@mui/material/Popover"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//import {logger } from "@indigenux/indi";
const NavItem = _ref => {
  let {
    title,
    id,
    items,
    colorInvert = false,
    href
  } = _ref;
  const theme = (0, _styles.useTheme)();
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const [openedPopoverId, setOpenedPopoverId] = (0, _react.useState)(null);
  const handleClick = (event, popoverId, href) => {
    //logger.debug(event.target);
    //logger.debug(popoverId);
    setAnchorEl(event.target);
    setOpenedPopoverId(popoverId);
    if (href) {
      window.location = href;
      return;
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpenedPopoverId(null);
  };
  const [activeLink, setActiveLink] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    setActiveLink(window && window.location ? window.location.pathname : '');
  }, []);
  const hasActiveLink = () => items ? items.find(i => i.href === activeLink) : false;
  const linkColor = colorInvert ? 'common.white' : 'text.primary';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      display: 'flex',
      alignItems: 'center',
      "aria-describedby": id,
      sx: {
        cursor: 'pointer'
      },
      onClick: e => handleClick(e, id, href),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        fontWeight: openedPopoverId === id || hasActiveLink() ? 700 : 400,
        color: linkColor,
        children: title
      }), items ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandMore.default, {
        sx: {
          marginLeft: theme.spacing(1 / 4),
          width: 16,
          height: 16,
          transform: openedPopoverId === id ? 'rotate(180deg)' : 'none',
          color: linkColor
        }
      }) : ""]
    }), items ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Popover.default, {
      elevation: 3,
      id: id,
      open: openedPopoverId === id,
      anchorEl: anchorEl,
      onClose: handleClose,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      sx: {
        '.MuiPaper-root': {
          maxWidth: items.length > 12 ? 350 : 250,
          padding: 2,
          marginTop: 2,
          borderTopRightRadius: 0,
          borderTopLeftRadius: 0,
          borderBottomRightRadius: 8,
          borderBottomLeftRadius: 8,
          borderTop: "3px solid ".concat(theme.palette.primary.main)
        }
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        container: true,
        spacing: 0.5,
        children: items.map((p, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          item: true,
          xs: items.length > 12 ? 6 : 12,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_.Button, {
            component: 'a',
            href: p.href,
            fullWidth: true,
            sx: {
              justifyContent: 'flex-start',
              color: activeLink === p.href ? theme.palette.primary.main : theme.palette.text.primary,
              backgroundColor: activeLink === p.href ? (0, _styles.alpha)(theme.palette.primary.main, 0.1) : 'transparent',
              fontWeight: activeLink === p.href ? 600 : 400
            },
            children: [p.title, p.isNew && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
              padding: 0.5,
              display: 'inline-flex',
              borderRadius: 1,
              bgcolor: 'primary.main',
              marginLeft: 2,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
                variant: 'caption',
                sx: {
                  color: 'common.white',
                  lineHeight: 1
                },
                children: "new"
              })
            })]
          })
        }, i))
      })
    }) : ""]
  });
};
NavItem.propTypes = {
  title: _propTypes.default.string.isRequired,
  id: _propTypes.default.string.isRequired,
  colorInvert: _propTypes.default.bool
};
var _default = exports.default = NavItem;